import { FC } from "react";

import { Button } from "@/components/ui/button";
import { ButtonProps } from "@/components/ui/button/types";

type Props = ButtonProps & {
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
};

export const ResponsiveButton: FC<Props> = ({
  leftIcon,
  rightIcon,
  children,
  ...props
}) => (
  <Button {...props}>
    {leftIcon}
    <span className="hidden sm:inline">{children}</span>
    {rightIcon}
  </Button>
);
